import { useContext } from "react";
import Card from "../../../components/card/card";
import {
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../../context/user-appointment-context";

const PhoneVerified = () => {
  const {
    state: { activeStep, isUserExisted },
    userDispatcher,
  } = useContext(UserAppointmentContext);
  
  const handleContinue = () => {
    const nextStep = isUserExisted ? 9 : activeStep + 1;
    userDispatcher({
      type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
      payload: nextStep,
    });
  };

  return (
    <Card
      title={"Your phone number has been verified successfully"}
      description={"Please press continue to start the appointment process"}
      btnTitle={"Continue"}
      onHandleClick={handleContinue}
      progress={activeStep * 5}
    ></Card>
  );
};

export default PhoneVerified;
